import { render, staticRenderFns } from "./PremioBox.vue?vue&type=template&id=2c715ac0"
import script from "./PremioBox.vue?vue&type=script&lang=js"
export * from "./PremioBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports